import { toast } from "react-toastify";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { createContext, useContext, useMemo } from "react";

import api from "libs/api";

const WebsiteAccessDataContext = createContext();

const WebsiteAccessDataProvider = ({ children }) => {
  const { t } = useTranslation();
  const { search } = useLocation();
  const { id } = useParams();

  const query = new URLSearchParams(search);
  const fixedId = query.get("id") || id;

  const { isLoading: loading, data } = useQuery({
    queryKey: ["websites-access-data", fixedId],
    queryFn: () => api.get(`/client/websites/${fixedId}/access-data`),
  });

  const updateData = (values) =>
    new Promise(async (resolve, reject) => {
      toast.dismiss();

      try {
        await api.put(`/client/websites/${fixedId}/access-data`, values);

        toast.success(t("Saved successfully."));
        resolve();
      } catch (err) {
        toast.error("Something went wrong.");
        reject(err);
      }
    });

  const value = useMemo(() => {
    return {
      data,
      loading,
      website_id: id,
      updateData,
    };
    // eslint-disable-next-line
  }, [data, id, loading]);

  return (
    <WebsiteAccessDataContext.Provider value={value}>
      {children}
    </WebsiteAccessDataContext.Provider>
  );
};

const useWebsiteAccessData = () => useContext(WebsiteAccessDataContext);
export { WebsiteAccessDataContext, useWebsiteAccessData };
export default WebsiteAccessDataProvider;
